var thumbnail_pos = 0;

function on_prev_btn_click(el) {
    return function () {
        if(thumbnail_pos > 0) thumbnail_pos--;
        let thumbnail = el.children[thumbnail_pos].querySelector('button');
        el.scroll({top: ((el.scrollHeight / el.children.length) * (thumbnail_pos + 1))})
        thumbnail.click();
    }
}

function on_next_btn_click(el) {
    return function () {
        if(el.children[thumbnail_pos + 1] != undefined) thumbnail_pos++;
        else return;
        let thumbnail = el.children[thumbnail_pos].querySelector('button');
        el.scroll({top: ((el.scrollHeight / el.children.length) * (thumbnail_pos + 1))})
        thumbnail.click();
    }
}

function on_scrolled_content(el) {
    let prev_btn = document.querySelector('.thumbnail-slider-alt-btn.alt-prev');
    prev_btn.style.display = 'block';
    prev_btn.addEventListener('click', on_prev_btn_click(el));
    let next_btn = document.querySelector('.thumbnail-slider-alt-btn.alt-next');
    next_btn.style.display = 'block';
    next_btn.disabled = false;
    next_btn.addEventListener('click', on_next_btn_click(el));
    let thumbnail_btns = el.querySelectorAll('button');
    for(let x=0; x<thumbnail_btns.length; x++) {
        const thumbnail_btn = thumbnail_btns[x];
        thumbnail_btn.addEventListener('click', function() {
            let els = Array.from(this.parentElement.parentElement.children);
            let index = els.indexOf(this.parentElement);
            thumbnail_pos = index;
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    let ul_slider = document.querySelector('ul.thumbnail-list');
    if(ul_slider.scrollHeight > ul_slider.offsetHeight) on_scrolled_content(ul_slider);
});